module.exports = __webpack_public_path__ + "static/media/icon2.427d62f7.svg";